import React, { useState, useEffect, useMemo } from 'react';
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
} from 'reactstrap';
import { Trans } from "react-i18next";
import { useOrganisationContext } from 'hooks';


const ConnectToXero = ({isGuideOpen, setToggle, t, isLive, user}) => {
    
    const [currentStage, setCurrentStage] = useState(0);

    useEffect(() => {
        
        if (!isLive) {
            checkAndPopModal();
        };
    }, [isLive]);

    const stages = useMemo(() => [
        {
            title: t('Follow up steps to connect xero'),
            content:   t(`This guide will walk you through the steps to seamlessly connect your Hesaab account with Xero. By following these instructions, you'll be able to sync your financial data between the two platforms, enabling better accounting and financial management for your business.`),
            image: <img src="/images/step 0 guide xero.jpg"  height={"290px"} width={"85%"}/> 
        },
        {
            title: t('1 - Click on the Highlighted Section'),
            content: t(`Once logged in to your account as a subscriber. navigate to the highlighted section. Clicking on this section will display a list of available organizations, along with a "Manage All" button for easy access.`),
            image: <img src="/images/step 1 to open the orgs list.png" alt="Encircled Section"  height={"290px"} width={"85%"}/> 
        },
        {
            title: t('2 - Manage All Organizations or Add a New One'),
            content: t('If organizations are available, a list will pop up. If no organizations are listed,  the "+" button to create a new organization. If you already have existing organizations, you can click the "Manage All" button, which will take you to the organization management page.'),
            image: <img src="/images/step 2 to click on manage all.png" alt="Encircled Section" height={"290px"} width={"85%"} />
        },
        {
            title: t('3 - Add a New One Organisation'),
            content: t('If no organizations are created or listed, you can click on the "+ Add New Organization" button to create one. After this process, you will have the option to connect with Xero.'),
            image: <img src="/images/step 3-1  xero guide.png" alt="Encircled Section" height={"290px"} width={"85%"} /> 
        },
        {
            title: t('Or Connect to an Existing Organization'),
            content: t('If you have one or more organizations already created, you can choose which one you want to connect with Xero. Simply click on the edit icon (pencil icon) next to the desired organization, and you will be taken to the edit organization page where you will start connecting the hesaab with xero.'),
            image: <img src="/images/step 3-2  xero guide.png" alt="Encircled Section" height={"290px"} width={"85%"} /> 
        },
        {
            title: t(' 4 - Click on "Connect to Xero"'),
            content: t("Now that you're on the edit organization page after clicking the Edit button in the previous step, you need to click the 'Connect to Xero' button shown in the image below to begin the connection process. After clicking this button, you'll be redirected to Xero. If you're already logged in, the connection process will proceed; otherwise, you'll be prompted to enter your login credentials."),
            image: <img src="/images/step 4 xero guide.png" alt="Encircled Section" height={"290px"} width={"85%"} /> 
        },
        {
            title: t(' 5 - Select any organisation from dropdown'),
            content: t("If you're already logged in, you'll be prompted to select an organization from the dropdown menu, as shown in the image below. Once you select an organization, you'll also see a summary of what you can access on Hesaab using that organization."),
            image: <img src="/images/step 5 to select the orgs from xero.png" alt="Encircled Section" height={"290px"} width={"85%"} /> 
        },
        { 
            title: t('6 - Click "Allow Access" to Complete the Xero Connection'),
            content: t("After selecting an available organization as shown in the image above, click the 'Allow Access' button. Before granting access, please review all permissions provided by Xero for the selected organization to ensure they meet your requirements."),
            image: <img src="/images/step 6 to allow access on xero.png" alt="Encircled Section" height={"290px"} width={"85%"}/> 
        },
        { 
            title: t('7 - Confirmation: Connection to Xero Successful'),
            content: t(`After clicking the "Allow Access" button, Hesaab will connect to Xero for the selected  organization. You will be automatically redirected to the organization page where you previously clicked 'Connect to Xero.' This time, the page will display "Connected to [Your Organization Name]."`),
            image: <img src="/images/step 7 after allowing access.png" alt="Encircled Section" height={"290px"} width={"85%"} />
        },
      ]);

      const handleNext = () => {
        if (currentStage < stages.length - 1) {
          setCurrentStage(currentStage + 1);
        }
      };
    
      const handlePrevious = () => {
        if (currentStage > 0) {
          setCurrentStage(currentStage - 1);
        }
      };
    
      const handleClose = () => {
        setToggle(false);
        setCurrentStage(0);
      };

      const checkAndPopModal = () => {
        return //removed due to other steps model
    };

    return (

        <Modal size="lg" isOpen={isGuideOpen} toggle={() => setToggle(false)}>
            <ModalHeader toggle={() => setToggle(false)}>
                <Trans>{stages[currentStage].title}</Trans>
            </ModalHeader>
            <ModalBody>
            <p style={{height: "90px"}}>{stages[currentStage].content}</p>
            <div className='row'>
                <div className="col-12 text-center" style={{height: "290px"}}>
                    {stages[currentStage].image}
                </div>
            </div>
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={handleClose}>
                    <Trans>Skip</Trans>
                </Button>
                <Button
                    color='primary'
                    onClick={handlePrevious}
                    disabled={currentStage === 0}
                >
                    <Trans>Previous</Trans>
                </Button>
                <Button
                    color='primary'
                    variant="primary"
                    onClick={handleNext}
                    disabled={currentStage === stages.length - 1}
                >
                    <Trans>Next</Trans>
                </Button>
            </ModalFooter>
        </Modal>
    );
}
export default ConnectToXero;
